module.exports = __webpack_public_path__ + "img/c66d01c5e0273d8d5dc47add52f65fe3.0cc6b733.jpg";